module.exports = __webpack_public_path__ + "static/img/consultation-qr-code.95bddd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consultation-qr-code.png
// module id = Ulx4
// module chunks = 1